// extracted by mini-css-extract-plugin
module.exports = {"errors":"index_errors_3Yrkb","container":"index_container_14RSP","footerNav":"index_footerNav_NGjvU"};